<template>
  <div>
    <component
      :is="eleName"
      :element-data="elementData"
      :trade-data="tradeData"
      :fund-code="fundCode"
      :merge-data="mergeData"
      :product-seats-info="productSeatsInfo"
      :index-info="indexInfo"
    />
  </div>
</template>

<script>
import eventBus from '@fund/basic-lib/dist/lib/eventBus';
import ProductInfo from './ProductInfo.vue';
import OnePage from './OnePage.vue';
import SameProduct from './SameProduct.vue';
import MarketOnePage from './MarketOnePage.vue';

export default {
  props: {
    elementData: Object,
    mergeData: Object,
    tradeData: Array,
    fundCode: String,
    productSeatsInfo: Object,
    indexInfo: {
      default: () => {},
      type: Object,
    },
  },

  components: {
    ProductInfo,
    OnePage,
    SameProduct,
    MarketOnePage,
  },

  data() {
    return {
      eleName: 'ProductInfo',
    };
  },

  computed: {
    tabBgColor() {
      return {
        light: '#f5f5f5',
        dark: '#010101',
      };
    },
  },

  mounted() {
    eventBus.$on('high-end-product-change-tab', (res) => {
      this.eleName = res?.eleName || 'ProductInfo';
    });
  },

};
</script>

<style scoped>

</style>
